const THREE = require('three')
import raf from 'src/components/game/raf'
import _ from 'lodash'
import {loadingManager, load, registerSize} from '../../loader'
import {TimelineMax, TweenMax, Cubic} from 'gsap'

const fontUrl = require('url-loader?limit=1!assets/fonts/digital.ttf')
registerSize(fontUrl, 1000)

// *****************************************************************
//
// FOREGROUND
//
// *****************************************************************
let geometry = new THREE.PlaneBufferGeometry( 128, 128, 1 )
let canvas = document.createElement('canvas')
canvas.width = 128
canvas.height = 128
let ctx = canvas.getContext('2d')
let texture = new THREE.Texture(canvas)
let material = new THREE.MeshBasicMaterial({
  map: texture,
  transparent: true
})
material.depthTest = false
material.depthWrite = false
export let mesh = new THREE.Mesh(geometry, material)
mesh.name = 'dashboard-counter-bg'
mesh.scale.setScalar(0.35)
mesh.material.opacity = 0
export default mesh


export let start = (seconds) => {
  let tl = new TimelineMax()
  tl.to(mesh.material, seconds, {opacity: 1, ease: Cubic.easeInOut})
}

export let reset = (seconds) => {
  mesh.material.opacity = 0
}


// *****************************************************************
//
// DRAW
//
// *****************************************************************


let fontSize = 93
let alpha = 0.25
let fontColor = '#FFFFFF'
ctx.font = `${fontSize}px digital`
ctx.fillStyle = fontColor

export const draw = function () {

  // clear
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  // bg
  ctx.font = `${fontSize}px digital`
  ctx.fillStyle = `rgba(255, 255, 255, ${alpha})`
  ctx.fillText('88', 0, fontSize)
  const textWidth = ctx.measureText('88').width

  // unit
  ctx.font = `${fontSize / 2}px digital`
  ctx.fillStyle = fontColor
  ctx.fillText('km', textWidth, fontSize )

  // update
  texture.needsUpdate = true
}

load(fontUrl, new THREE.FileLoader(loadingManager), (results)=> {
  draw()
})







// WEBPACK FOOTER //
// ./src/components/game/ui/dashboard/counterBg.js